<template>
    <el-container>
      <el-container v-if="ifshowadd">
        <el-aside style="min-height: 600px;min-width:500px;overflow: auto;">
          <el-table
            :data="goodsbrandtb"
            fit
            ref="gbrandtb"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            highlight-current-row
            @selection-change="sbselchange"
            @current-change="sbrandchange">
            <el-table-column
              prop="name"
              label="名称"
            >
            </el-table-column>
            <el-table-column
              prop="burl"
              label="Logo"
              width="140px">
              <template slot-scope="scope">
                <div v-if="scope.row.burl" >
                  <img :src="scope.row.burl" class="avatarimg">
                </div>
                <div v-else>
                  {scope.row.burl}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="slogan"
              label="标志语">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑当前品牌" placement="top-start">
                  <i class="fa el-icon-edit-outline gtopicon" v-on:click="editbrand(scope.$index, goodsbrandtb)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除当前品牌" placement="top-start">
                  <i class="fa el-icon-delete gtopicon" v-on:click="removebrand(scope.$index, goodsbrandtb)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-aside>
        <el-main style="margin-left: 20px;padding: 0 20px 0 10px;flex: 1">
          <el-container>
            <el-card style="width:100%">
              <div slot="header" style="height: 40px; display: flex; justify-content:space-between; align-items: center;">
                <span>新增产品品牌</span>
                <i class="el-icon-close" style="cursor: pointer;" @click="ifshowadd=false"></i>
              </div>
              <el-form label-width="100px" label-position="left">
                <el-form-item label="品牌名称:">
                  <el-input v-model="ed_brandname"  auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Logo:">
                  <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" bucketpath="ecomm/brands"></UpLoadFile>
                </el-form-item>
                <el-form-item label="宣传语:">
                  <el-input type="textarea" v-model="ed_slogan" auto-complete="off"></el-input>
                </el-form-item>
                <el-tooltip style="margin-top: 30px;" class="item" effect="dark" content="更改当前数据" placement="top-start">
                  <el-button type="success" v-on:click="savebrand" icon="el-icon-edit-outline" >保存</el-button>
                </el-tooltip>
              </el-form>
            </el-card>
          </el-container>
        </el-main>
      </el-container>
      <el-container v-else>
        <el-main>
          <el-table
            :data="goodsbrandtb"
            fit
            ref="gbrandtb"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            highlight-current-row
            @selection-change="sbselchange"
            @current-change="sbrandchange">
            <el-table-column
              prop="name"
              label="名称"
            >
            </el-table-column>
            <el-table-column
              prop="burl"
              label="Logo"
              width="140px">
              <template slot-scope="scope">
                <div v-if="scope.row.burl" >
                  <img :src="scope.row.burl" class="avatarimg">
                </div>
                <div v-else>
                  {scope.row.burl}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="slogan"
              label="标志语">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑当前品牌" placement="top-start">
                  <i class="fa el-icon-edit-outline gtopicon" v-on:click="editbrand(scope.$index, goodsbrandtb)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除当前品牌" placement="top-start">
                  <i class="fa el-icon-delete gtopicon" v-on:click="removebrand(scope.$index, goodsbrandtb)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
      <el-footer>
        <el-button type="primary" icon="el-icon-edit" v-on:click="addnewbrand" round>新增品牌</el-button>
      </el-footer>
    </el-container>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import UpLoadFile from '../upload/UpLoadFile'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GBrand',
    components: {
      UpLoadFile
    },
    data () {
      return {
        ifshowfile:false, // 上传页面参数： 是否显示文件
        curfilepath: '', // 上传页面参数： 当前选中图标文件路径
        ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
        ifupload: false, // 上传页面参数： 是否显示上传参数
        goodsbrandtb: [], // 品牌数据
        select_brand: '',
        ed_brandname: '',
        ed_slogan: '',
        savemodel: 'new',
        khid: '', // 所属客户ID
        ifshowadd: false
      }
    },
    mounted: function () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.getbranddata()
      }
    },
    methods: {
      refreshdata () {
        that.getbranddata()
        this.savemodel = 'new'
        this.ifshowadd = false
        this.ed_brandname = ''
        this.ed_slogan = ''
        that.curfilepath = ''
      },
      getbranddata () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygbrand',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
            console.log('已获取网络数据')
            if (res.data.length > 0) {
              that.goodsbrandtb = res.data
            } else {
              that.goodsbrandtb = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addnewbrand () {
        this.savemodel = 'new'
        this.ifshowadd = true
        this.ed_brandname = ''
        this.ed_slogan = ''
        that.curfilepath = ''
      },
      editbrand (index, data) {
        that.select_brand = data[index]
        this.ifshowadd = true
        this.savemodel = 'update'
        if (that.select_brand.burl) {
          that.curfilepath = that.select_brand.burl
        } else {
          that.curfilepath = ''
        }
        this.ed_brandname = that.select_brand.name
        this.ed_slogan = that.select_brand.slogan
      },
      removebrand (index, data) {
        var curselectdata = data[index]
        // 提交到后台服务器做处理
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delgbrand',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$options.methods.getbranddata()
              that.$message({
                type: 'success',
                message: '删除成功'
              })
            } else {
              that.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
            console.log('error' + error)
          })
      },
      savebrand () {
        var adata
        if (this.savemodel === 'new') {
          adata = {
            id: '',
            name: this.ed_brandname,
            burl: this.curfilepath,
            slogan: this.ed_slogan,
            cusid: this.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
        } else {
          adata = {
            id: that.select_brand.id.toString(),
            name: this.ed_brandname,
            burl: this.curfilepath,
            slogan: this.ed_slogan,
            cusid: this.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addgbrand',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            if (res.data.result === 'success') {
              that.$options.methods.getbranddata()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      sbselchange (selection) {
        that.select_brand = selection
        window.console.log('选择品牌',that.select_brand)
      },
      sbrandchange (val) {
        that.select_brand = val
        this.$emit('loadgbrand',that.select_brand);
      },
      upok (curpath,fileList) {
        that.curfilepath = curpath
        window.console.log(fileList)
      },
      slectbrand () {
        this.$emit('loadgbrand',that.select_brand);
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/GBrand.vue